import React from "react";
import { Tooltip } from "@mui/material";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import type { BulkActionDescriptor } from "@/components/tables/toolbar/bulkActionsSlot";

interface CrudTableBulkActionButtonsProps {
  actions: BulkActionDescriptor[];
  noRowsSelected: boolean;
}

const CrudTableBulkActionButtons = ({
  actions,
  noRowsSelected,
}: CrudTableBulkActionButtonsProps) => (
  <>
    {actions.map((action) => {
      const button = (
        <GenericButton
          color={action.color ?? "secondary"}
          startIcon={action.icon}
          disabled={noRowsSelected || Boolean(action.disabled)}
          onClick={action.onClick}
        >
          {action.label}
        </GenericButton>
      );
      return action.tooltip ? (
        <Tooltip key={action.key} arrow title={action.tooltip} placement="bottom">
          {button}
        </Tooltip>
      ) : (
        <React.Fragment key={action.key}>{button}</React.Fragment>
      );
    })}
  </>
);

export default CrudTableBulkActionButtons;
